// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#3fa7e1","secondaryColor":"#A96AB5"};